exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".appFooterLinks{position:fixed;bottom:0;right:0;border-top:1px solid var(--grey-40);border-left:1px solid var(--grey-40);padding:0 3px;background-color:var(--grey-20)}.appFooterLinksClose,.appFooterLinksLink{display:inline-block;padding:3px 5px;color:var(--blue-60);text-decoration:none}.appFooterLinksClose:hover,.appFooterLinksLink:hover{text-decoration:underline}.appFooterLinksClose{border:none;margin:0;font:inherit;background:none;cursor:pointer}@media (max-width:767px){.appFooterLinks{width:100%;text-align:center}}", ""]);

// exports
